(() => {
  'use strict';

  const copy = {
    it: { trigger: 'Ingredienti e valori nutrizionali', loading: 'Caricamento delle informazioni sul prodotto…', unavailable: 'Informazioni non disponibili per questo articolo.', ingredients: 'Ingredienti', allergens: 'Allergeni', nutrition: 'Valori nutrizionali per 100 g' },
    es: { trigger: 'Ingredientes y valores nutricionales', loading: 'Cargando la información del producto…', unavailable: 'Información no disponible para este artículo.', ingredients: 'Ingredientes', allergens: 'Alérgenos', nutrition: 'Información nutricional por 100 g' },
    en: { trigger: 'Ingredients and nutrition', loading: 'Loading product information…', unavailable: 'Product information is not available for this item.', ingredients: 'Ingredients', allergens: 'Allergens', nutrition: 'Nutrition information per 100 g' },
  };
  const languageFor = (value) => copy[String(value || '').toLowerCase().slice(0, 2)] || copy.en;
  const headingNames = {
    ingredients: ['ingredienti', 'ingredientes', 'ingredients'],
    allergens: ['allergeni', 'alérgenos', 'alergenos', 'allergens'],
    nutrition: ['informazioni nutrizionali', 'información nutricional', 'informacion nutricional', 'nutrition information', 'nutritional information'],
  };
  const moduleScript = document.currentScript || document.querySelector('script[src*="product-card-specification-popover-20260804.js"]');
  const mapUrl = moduleScript?.dataset?.productSpecMapUrl || window.ProductCardSpecificationMapUrl;
  let productDataPromise;
  function productData() {
    if (!productDataPromise) {
      const source = mapUrl;
      if (!source) return Promise.reject(new Error('Product specification map missing'));
      productDataPromise = fetch(source, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error(`Product specification map failed (${response.status})`);
        return response.json();
      });
    }
    return productDataPromise;
  }
  function appendTextSection(panel, title, text) {
    if (!text) return false;
    const section = document.createElement('section');
    const heading = document.createElement('h4');
    const paragraph = document.createElement('p');
    heading.textContent = title;
    paragraph.textContent = text;
    section.append(heading, paragraph);
    panel.append(section);
    return true;
  }
  function appendNutritionTable(panel, title, nutrition) {
    if (!nutrition) return false;
    const rows = Array.isArray(nutrition)
      ? nutrition.map((cells) => cells.map((cell) => String(cell).replace(/\s+/g, ' ').trim()).filter(Boolean)).filter((cells) => cells.length >= 2)
      : Array.from(nutrition.querySelectorAll('tr')).map((row) => Array.from(row.querySelectorAll('th,td')).map((cell) => cell.textContent.replace(/\s+/g, ' ').trim()).filter(Boolean)).filter((cells) => cells.length >= 2);
    if (!rows.length) return false;
    const section = document.createElement('section');
    const heading = document.createElement('h4');
    const table = document.createElement('table');
    const body = document.createElement('tbody');
    heading.textContent = title;
    table.className = 'product-card-spec__table';
    rows.forEach(([name, value]) => {
      const row = document.createElement('tr');
      const label = document.createElement('th');
      const amount = document.createElement('td');
      label.scope = 'row'; label.textContent = name; amount.textContent = value;
      row.append(label, amount); body.append(row);
    });
    table.append(body); section.append(heading, table); panel.append(section);
    return true;
  }
  async function load(wrapper) {
    if (wrapper.dataset.loaded === 'true' || wrapper.dataset.loading === 'true') return;
    wrapper.dataset.loading = 'true';
    const language = languageFor(wrapper.dataset.productSpecLocale);
    const panel = wrapper.querySelector('[data-product-spec-panel]');
    const status = wrapper.querySelector('[data-product-spec-status]');
    status.textContent = language.loading;
    try {
      const product = (await productData())[wrapper.dataset.productSpecHandle];
      if (!product) throw new Error('Verified product data absent');
      panel.replaceChildren();
      const enoughData = appendTextSection(panel, language.ingredients, product.ingredients)
        && appendNutritionTable(panel, language.nutrition, product.nutrition);
      if (product.allergens) appendTextSection(panel, language.allergens, product.allergens);
      if (!enoughData) throw new Error('Required ingredient or nutrition table missing');
      wrapper.dataset.loaded = 'true';
      status.remove();
    } catch (error) {
      panel.replaceChildren();
      status.textContent = language.unavailable;
      wrapper.dataset.unavailable = 'true';
    } finally {
      delete wrapper.dataset.loading;
    }
  }
  function setOpen(wrapper, open) {
    const button = wrapper.querySelector('[data-product-spec-toggle]');
    wrapper.toggleAttribute('data-open', open);
    button?.setAttribute('aria-expanded', String(open));
    if (open) load(wrapper);
  }
  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest?.('product-card');
    const wrapper = card?.querySelector('[data-product-spec]');
    if (wrapper && event.pointerType !== 'touch') load(wrapper);
  }, { passive: true });
  document.addEventListener('focusin', (event) => {
    const card = event.target.closest?.('product-card');
    const wrapper = card?.querySelector('[data-product-spec]');
    if (wrapper) load(wrapper);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-product-spec-toggle]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const wrapper = button.closest('[data-product-spec]');
    setOpen(wrapper, !wrapper.hasAttribute('data-open'));
  });
})();
